var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'container': _vm.useContainer, 'redirect-block-select': _vm.blockParams?.isUrl },style:({
    'background-color': _vm.useBackgroundColor,
    'padding-top': _vm.paddingTop ? _vm.paddingTop + 'px' : '',
    'padding-bottom': _vm.paddingBottom ? _vm.paddingBottom + 'px' : ''
  }),on:{"click":function($event){return _vm.$emit('block:redirect')}}},[_c('div',{staticClass:"number-box"},[_c('div',{staticClass:"number-box__title"},[_vm._v("\n      "+_vm._s(_vm.mainFields?.title?.value)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"number-box__text",domProps:{"innerHTML":_vm._s(_vm.mainFields?.text?.value)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }